import usePrivateAxios from "@/common/api/usePrivateAxios";
import { ErrorResponse } from "@/common/types/errorResponse";
import { useMutation } from "@tanstack/react-query";
import z, { AnyZodObject } from "zod";

interface UseCreateMaintenanceForwardingProps {
  workflowId?: string;
  directiveEntryType?: string;
  schema: AnyZodObject;
  onSuccess: () => void,
  onError: (error: ErrorResponse) => void;
}

export const useCreateMaintenanceForwarding = ({
  workflowId,
  directiveEntryType,
  schema,
  onSuccess,
  onError,
}: UseCreateMaintenanceForwardingProps) => {
  const privateAxios = usePrivateAxios();

  type DynamicSchemaValidationSchema = z.infer<typeof schema>;

  return useMutation({
    mutationKey: ['createMaintenanceForwarding', workflowId, directiveEntryType],
    mutationFn: (form: DynamicSchemaValidationSchema) => {
      const payload = {
        workflow_id: workflowId,

        directive_entry_type: directiveEntryType,
        directive_entry_attributes: {
          complexity_id: form.complexity?.value,
        },

        establishment_choice_entry_type: form.establishment_choice_entry_type,
        establishment_choice_entry_attributes: {
          establishment_id: form.establishment_choice_entry_attributes?.establishment_id,
        },

        checkin_entry_type: form.checkin_entry_type,
        checkin_entry_attributes: {
          responsible_id: form.checkin_entry_attributes?.responsible?.value,
        },
      };

      return privateAxios.post('/maintenance/forwardings', {
        forwarding: payload,
      });
    },
    onSuccess,
    onError,
  });
};
